import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { iconsAsset } from "../../environment/icons/iconExport";
import MultipartUploadFileArea from "./MultipartUploadFileArea";
import PowerShellCommand from "./PowerShellCommand";
import { AD_GROUP_POLICY_COMMAND, MicrosoftADFiles } from "./constants";

const GroupPolicyExportStep = ({ statusData }) => {
  const colors = useColors();

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant={"subtitle1"}>
        Export & Upload Group Policy Results
      </Typography>

      {/* SUB-STEP 1 */}
      <Box display="flex" flexDirection="column" gap={1} padding={2}>
        <Box display="flex" flexDirection="row" gap={1}>
          <Typography variant={"body2"} noWrap>
            1.
          </Typography>
          <Typography display="inline-block" variant={"body2"} noWrap>
            Run the script below as{" "}
            <Typography display="inline-block" variant={"subtitle2"}>
              Administrator
            </Typography>{" "}
            on one representative machine from each system type: Domain
            Controller, Server, and Endpoint.
          </Typography>
        </Box>

        {/* INSTRUCTIONS */}
        <Box display="flex" flexDirection="column" gap={1} paddingLeft={2}>
          <Typography variant={"body2"} color={colors.text_secondary}>
            This generates an HTML file with Group Policy results.
          </Typography>
        </Box>
        <PowerShellCommand
          command={AD_GROUP_POLICY_COMMAND}
          label="Run as Administrator"
          minWidth="400px"
        />
      </Box>

      {/* SUB-STEP 2 */}
      <Box display="flex" flexDirection="column" gap={1} padding={2}>
        <Box display="flex" flexDirection="row" gap={1}>
          <Typography variant={"body2"}>2.</Typography>
          <Typography variant={"body2"}>
            Upload the HTML file from each machine:
          </Typography>
        </Box>
        {/* INSTRUCTIONS */}
        <Box display="flex" flexDirection="column" gap={2} paddingLeft={2}>
          <Box display="flex" flexDirection="row" gap={2} flexWrap="wrap">
            <MultipartUploadFileArea
              fileKey={MicrosoftADFiles.DOMAIN_CONTROLLER.key}
              initialFileName={
                statusData?.file_mapping?.[
                  MicrosoftADFiles.DOMAIN_CONTROLLER.key
                ]?.original_file_name
              }
              fileFormat="HTML"
              label={
                <Box display="flex" alignItems="center" gap="6px">
                  <SvgToIcon
                    IconLogo={iconsAsset.DomainControllerIcon}
                    width={16}
                  />
                  <Typography variant={"body2"} color={colors.text_secondary}>
                    Domain Controller
                  </Typography>
                </Box>
              }
            />
            <MultipartUploadFileArea
              fileKey={MicrosoftADFiles.SERVER.key}
              initialFileName={
                statusData?.file_mapping?.[MicrosoftADFiles.SERVER.key]
                  ?.original_file_name
              }
              fileFormat="HTML"
              label={
                <Box display="flex" alignItems="center" gap="6px">
                  <SvgToIcon
                    IconLogo={iconsAsset.AssetsServerIcon}
                    width={16}
                  />
                  <Typography variant={"body2"} color={colors.text_secondary}>
                    Server
                  </Typography>
                </Box>
              }
            />
            <MultipartUploadFileArea
              fileKey={MicrosoftADFiles.ENDPOINT.key}
              initialFileName={
                statusData?.file_mapping?.[MicrosoftADFiles.ENDPOINT.key]
                  ?.original_file_name
              }
              fileFormat="HTML"
              label={
                <Box display="flex" alignItems="center" gap="6px">
                  <SvgToIcon IconLogo={iconsAsset.EndpointIcon} width={16} />
                  <Typography variant={"body2"} color={colors.text_secondary}>
                    Endpoint
                  </Typography>
                </Box>
              }
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default GroupPolicyExportStep;
